import React from 'react';
import classNames from 'classnames';
import {SectionTilesProps} from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Image from "../elements/Image";

const propTypes = {
    ...SectionTilesProps.types
}

const defaultProps = {
    ...SectionTilesProps.defaults
}

const MentorsSection = ({
                         className,
                         topOuterDivider,
                         bottomOuterDivider,
                         topDivider,
                         bottomDivider,
                         hasBgColor,
                         invertColor,
                         pushLeft,
                         ...props
                     }) => {

    const outerClasses = classNames(
        'testimonial section',
        topOuterDivider && 'has-top-divider',
        bottomOuterDivider && 'has-bottom-divider',
        hasBgColor && 'has-bg-color',
        invertColor && 'invert-color',
        className
    );

    const innerClasses = classNames(
        'testimonial-inner section-inner',
        topDivider && 'has-top-divider',
        bottomDivider && 'has-bottom-divider'
    );

    const tilesClasses = classNames(
        'tiles-wrap',
        pushLeft && 'push-left'
    );

    const sectionHeader = {
        title: 'あなたをバックアップするITサポーター',
        paragraph: '特別顧問・監修　東京情報大学教授　三宅　修平'

    };

    return (
        <section
            {...props}
            className={outerClasses}
            id="mentors"
        >
            <div className="container">
                <div className={innerClasses}>
                    <SectionHeader data={sectionHeader} className="center-content"/>
                    <div className={tilesClasses}>

                        <div className="tiles-item reveal-from-right" data-reveal-delay="200">
                            <div className="tiles-item-inner">
                                <div className="testimonial-item-content">
                                    <div className="center-content mb-32">
                                        <Image
                                            src={require('./../../assets/images/mentor/komoto.png')}
                                            alt="Mentor's avatar"
                                            width={124}
                                            height={124}/>
                                    </div>
                                    <p className="text-color-high text-sm mb-0">
                                        — 古本雅裕
                                    </p>
                                </div>
                                <div className="testimonial-item-footer text-xs mt-32 mb-0 has-top-divider">
                                    <p className="testimonial-item-name text-color-high mb-0">株式会社OASYS Technologies</p>
                                    <p className="testimonial-item-link">代表取締役</p>
                                </div>
                            </div>
                        </div>

                        <div className="tiles-item reveal-from-right" data-reveal-delay="200">
                            <div className="tiles-item-inner">
                                <div className="testimonial-item-content">
                                    <div className="center-content mb-32">
                                        <Image
                                            src={require('./../../assets/images/mentor/kimura.png')}
                                            alt="Mentor's avatar"
                                            width={124}
                                            height={124}/>
                                    </div>
                                    <p className="text-color-high text-sm mb-0">
                                        — 木村 光範
                                    </p>
                                </div>
                                <div className="testimonial-item-footer text-xs mt-32 mb-0 has-top-divider">
                                    <p className="testimonial-item-name text-color-high mb-0">一般社団法人 IT人材育成フォーラム</p>
                                    <p className="testimonial-item-link">代表理事</p>
                                </div>
                            </div>
                        </div>

                        <div className="tiles-item reveal-from-right" data-reveal-delay="200">
                            <div className="tiles-item-inner">
                                <div className="testimonial-item-content">
                                    <div className="center-content mb-32">
                                        <Image
                                            src={require('./../../assets/images/mentor/sawada.png')}
                                            alt="Mentor's avatar"
                                            width={124}
                                            height={124}/>
                                    </div>
                                    <p className="text-color-high text-sm mb-0">
                                        — 澤田　純平
                                    </p>
                                </div>
                                <div className="testimonial-item-footer text-xs mt-32 mb-0 has-top-divider">
                                    <p className="testimonial-item-name text-color-high mb-0">株式会社SYN</p>
                                    <p className="testimonial-item-link">代表取締役</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
}

MentorsSection.propTypes = propTypes;
MentorsSection.defaultProps = defaultProps;

export default MentorsSection;